import { useReducer } from 'react'
import { getCurrentFlow } from '../helper/flow'

const ACTIONS = {
  SET_PAGE_FLOW: 'SET_PAGE_FLOW',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_IS_PENDING: 'SET_IS_PENDING'
}

const getInitState = props => {
  const {
    match: { params: { phase } }
  } = props
  return {
    pageFlow: getCurrentFlow(phase),
    isLoading: false,
    isPending: false
  }
}

const useUIState = props => {
  const reducer = (state, action) => {
    const { type, payload } = action
    switch (type) {
      case ACTIONS.SET_PAGE_FLOW:
        return { ...state, pageFlow: payload }
      case ACTIONS.SET_IS_LOADING:
        return { ...state, isLoading: payload }
      case ACTIONS.SET_IS_PENDING:
        return { ...state, isPending: payload }
      default:
        return state
    }
  }

  const [state, dispatch] = useReducer(reducer, props, getInitState)

  const setPageFlow = pageFlow => dispatch({
    type: ACTIONS.SET_PAGE_FLOW,
    payload: pageFlow
  })

  const setIsLoading = isLoading => dispatch({
    type: ACTIONS.SET_IS_LOADING,
    payload: isLoading
  })

  const setIsPending = isPending => dispatch({
    type: ACTIONS.SET_IS_PENDING,
    payload: isPending
  })

  const actions = {
    setPageFlow,
    setIsLoading,
    setIsPending
  }

  return { state, actions }
}

export default useUIState
